import SharedCategory from '@/shared/models/Category'
import Activation from './Activation'
import Rule from './Rule'
import ResellerType from './ResellerType'

export default class Category extends SharedCategory {
    resourceName() {
        return 'categories'
    }

    appends() {
        return ['reseller_type_ids']
    }

    relationships() {
        return {
            activations: new Activation(),
            rules: new Rule(),
            resellerTypes: new ResellerType(),
        }
    }

    computed() {
        return {
            active(category) {
                return category.deleted_at ? false : true
            },
        }
    }
}
